"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {addClass, closest, on, removeClass, findAllIn, findIn, find} from "@elements/dom-utils";
import Pristine from "../libs/pristine/pristine.js";
import {scrollTop} from "./ajax-form-extend";
import {translate} from '@elements/translations';

export function init() {
    onFind('.js-step-form', function (form) {

        let steps = findAllIn('.js-step-form__step', form);
        let legendItems = findAllIn('.js-step-form__legend-item', form);

        navigateTo(0, steps, legendItems, form);

        steps.forEach(function (step, index) {
            validateStep(step, steps, index, legendItems, form);
        })


        let summaryPrice = findIn('.js-step-form__summary-price', form);
        let priceItems = findAllIn('.js-step-form__item-count', form);
        let datePickerFrom = findIn('.js-datepicker-step-form__from', form);
        let datePickerTo = findIn('.js-datepicker-step-form__to', form);
        let endDate,
            startDate;

        let price = 0;

        if (document.documentElement.lang === "en") {
            price = price.toLocaleString("en-EN", {
                style: 'currency',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                currencyDisplay: 'symbol',
                currency: 'EUR'
            });
        } else if (document.documentElement.lang === "de") {
            price = price.toLocaleString("de-DE", {
                style: 'currency',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                currencyDisplay: 'symbol',
                currency: 'EUR'
            });
        }

        if (datePickerFrom != null){
            datePickerFrom.addEventListener('change', function (){
                startDate = findIn('.js-datepicker__alt-field', datePickerFrom).value;
            });
        }
        if (datePickerTo != null){
            datePickerTo.addEventListener('change', function (){
                endDate = findIn('.js-datepicker__alt-field', datePickerTo).value;
            });
        }

        if(summaryPrice && priceItems.length > 0) {
            summaryPrice.innerHTML = price; // TODO: if external -> no price

            priceItems.map(function(priceItem) {
                on('change', function() {
                    let summary = 0;
                    priceItems.map(function(item) {
                        let count = item.value;
                        summary += +item.dataset.stepFormItemPrice * count;
                    })

                    if(startDate != null && endDate != null){
                        let diffInMs = new Date(endDate) - new Date(startDate);
                        let diffInDays = diffInMs / (1000 * 60 * 60 * 24);
                        summary = summary*diffInDays;
                    }



                    if (document.documentElement.lang === "en") {
                        summary = summary.toLocaleString("en-EN", {
                            style: 'currency',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                            currencyDisplay: 'symbol',
                            currency: 'EUR'
                        });
                    } else if (document.documentElement.lang === "de") {
                        summary = summary.toLocaleString("de-DE", {
                            style: 'currency',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                            currencyDisplay: 'symbol',
                            currency: 'EUR'
                        });
                    }


                    summaryPrice.innerHTML = summary;
                }, priceItem);
            })
        }
    });
}

function navigateTo(index, steps, legendItems, form){
    steps.forEach(function (el) {
        removeClass('is-active', el);
    });

    legendItems.forEach(function (item) {
        removeClass('is-current', item);
    });

    addClass('is-active', steps[index]);
    addClass('is-current', legendItems[index]);

    if(index >= steps.length-1){
        let result = find('.js-step-form__result');
        let form = find('.js-step-form');
        showResults(result, form);
    }

    scrollTop(form);

}

function showResults(result, form){
    renderList(result, form);

    let resultRooms = find('.js-step-form__result-rooms', form);
    if(resultRooms){
        renderRoom(result, form);
    }

    let resultTeaser = find('.js-step-form__result-booking-teaser', form);
    if(resultTeaser){
        renderBookingTeaser(result, form);
    }

    scrollTop(form);
}

function renderRoom(result, form) {
    let rooms = findAllIn('.js-step-form__booking-item__room', form);
    let resultRooms = find('.js-step-form__result-rooms', form);
    let roomItems = [];
    let room;

    rooms.forEach(function (el, index){
        resultRooms.innerHTML= "";
        let nights = findIn('select', el);
        if(nights.classList.contains('has-value')){
            let roomDes = findIn('.js-step-form__booking-item__description', el);
            let roomName = findIn('.js-step-form__booking-item__name', el);
            let roomPrice = findIn('.js-step-form__price', el);
            let sum = findIn('.js-step-form__summary-price', form);

            room = {
                name: roomName.innerHTML,
                des: roomDes.innerHTML,
                night: nights.value,
                price: roomPrice.innerHTML,
                sum: sum.innerHTML,
            }
            roomItems.push(room);
        }
    });



    roomItems.forEach(function (el){
        let col = document.createElement("div");
        col.classList.add("col-12");

        let contentNights = `<div class="d-flex justify-content-between">
                        <div>
                            <div class="">${el.name}</div>
                            <div class="step-form__booking-item__description">${el.des}</div>
                        </div>
                        <div>${el.night}</div>
                        <div>
                            ${el.price}
                        </div>
                        </div>`

        col.innerHTML =  contentNights;
        resultRooms.appendChild(col);
    });


    renderSum(roomItems, resultRooms);

}


function renderBookingTeaser(result, form) {
    let rooms = findAllIn('.js-step-form__booking-item__room', form);
    let resultRooms = find('.js-step-form__result-booking-teaser', form);
    let roomItems = [];
    let room;

    rooms.forEach(function (el, index){
        resultRooms.innerHTML= "";
        let nights = findAllIn('select', el);
        let roomPrice = findAllIn('.step-form__price', el);
        let roomDes = findAllIn('.js-step-form__booking-item__description', el);

        nights.forEach(function (select, index){
            if(select.classList.contains('has-value')){
                let roomName = findIn('.js-step-form__booking-item__name', el);
                let sum = findIn('.js-step-form__summary-price', form);

                room = {
                    name: roomName.innerHTML,
                    night: select.value,
                    des: roomDes[index].innerHTML,
                    price: roomPrice[index].innerHTML,
                    sum: sum.innerHTML
                }
                roomItems.push(room);
            }
        })
    });

    let guestNames = findAllIn('.js-form-step__guest-name', form);

    let indexGuestName = 0;

    roomItems.forEach(function (el){
        let col = document.createElement("div");
        col.classList.add("col-12");

        let guestList = document.createElement("div");
        let separatorCol = document.createElement("div");
        addClass('col-12', separatorCol);
        let separator = document.createElement("div");
        addClass('step-form__separator', separator);

        separatorCol.appendChild(separator);

        let guestTitle = translate('congress.guests');
        addClass('mt-3', guestList);
        guestList.innerHTML="";
        for(let i = 0; i<el.night; i++){
            let item = document.createElement("div");
            let innerHtml = `<strong class="mr-2">${guestTitle} ${i +1 }: </strong>${guestNames[indexGuestName].value}`;
            item.innerHTML = innerHtml;
            guestList.append(item);
            indexGuestName++;
        }


        let contentNights = `<div class="d-flex justify-content-between">
                        <div>
                            <div class="">${el.name}</div>
                            <div class="step-form__booking-item__description">${el.des}</div>
                        </div>
                        <div class="me-2">${el.night}</div>
                        <div>
                            ${el.price}
                        </div>
                       
                        </div>`


        col.innerHTML =  contentNights;
        resultRooms.appendChild(separatorCol);
        resultRooms.appendChild(col);
        resultRooms.appendChild(guestList);
    });

    renderSum(roomItems, resultRooms);

}

function renderList(result, form) {
    let formElements = findAllIn('input:not([type=hidden]), textarea, select', form);

    let resultList = find('.js-step-form__result-list', form);

    let listItems = [];
    let item;

    formElements.forEach(function (el, index){
        if(resultList) {
            resultList.innerHTML= "";
        }
        let isRendered = el.getAttribute('data-label-hide');
        if(!isRendered){

            if(el.type ==='radio') {
                if(el.checked){
                    item = {
                        label: el.dataset.label ? el.dataset.label : el.getAttribute('name'),
                        value: el.dataset.result ? el.dataset.result : el.getAttribute('name'),
                    };
                    listItems.push(item);
                }
            }else if(el.tagName === 'SELECT'){
                let selectItem = el.options[el.selectedIndex].text;
                item = {
                    label: el.dataset.label ? el.dataset.label : el.getAttribute('name'),
                    value: selectItem,
                };
                listItems.push(item);
            }else{
                item = {
                    label: el.dataset.label ? el.dataset.label : el.getAttribute('name'),
                    value: el.value
                };
                listItems.push(item);
            }


        }
    });


    listItems.forEach(function (el){
        if (el.value){
            let item = document.createElement("div");
            let innerHtml = `<strong class="mr-2">${el.label}: </strong>${el.value}`;
            item.innerHTML = innerHtml;
            if(resultList){
                resultList.append(item);
            }
        }
    });
}

function renderSum(roomItems, resultRooms){
    let sum = document.createElement("div");
    sum.classList.add("col-12");
    let summaryTitle = translate('congress.summary') ;

    let sumInnerHtml = ` <div class="col-12">
                                    <div class="step-form__separator"></div>
                                </div>
                                <div class="col-12">
                                <div class="d-flex align-items-end justify-content-end mt-4">
                                    <div class="me-3">${summaryTitle}</div>
                                    <div class="h2 mb-0 js-step-form__summary-price">
                                        ${roomItems[0].sum}
                                    </div>
                                </div>
                            </div>`;

    sum.innerHTML = sumInnerHtml;
    resultRooms.appendChild(sum);
}

function validateStep(currentStep, steps, index, legendItems, form){

    let nextButtons = findAllIn('.js-step-form__next', currentStep);
    if (nextButtons.length > 0) {
        nextButtons.forEach(function (nextButton) {
            nextButton.addEventListener('click', function () {
                let pristine = new Pristine(currentStep);
                if (pristine.validate()) {
                    addClass('is-checked', legendItems[index]);
                    navigateTo(index +1 , steps, legendItems, form);
                }else{
                    removeClass('is-checked', legendItems[index]);
                }
            });
        });

    }

    let submitButton = findIn('.js-step-form__submit', currentStep);
    if (submitButton) {
        submitButton.addEventListener('click', function (evt) {
            let pristine = new Pristine(currentStep);
            if (!pristine.validate()) {
                evt.preventDefault();
            }
        });
    }

    let prevButton = findIn('.js-step-form__prev', currentStep);
    if (prevButton) {
        prevButton.addEventListener('click', function () {
            navigateTo(index-1 , steps, legendItems, form);
        });
    }
}

